import { type TranslationTree } from '@/i18n/types';

export const messages = {
  createTitle: 'Novo evento',
  editTitle: 'Editar evento',
  subtitle:
    'Depois de aprovado pela Bodyprint, o evento aparece no app para os atletas da região, ordenado pela distância.',
  optional: 'opcional',
  sections: {
    banner: 'Banner',
    info: 'Informações',
    when: 'Quando',
    where: 'Onde',
    link: 'Link externo',
  },
  name: 'Nome do evento',
  eventType: 'Tipo',
  noEventType: 'Selecione',
  description: 'Descrição',
  descriptionPlaceholder: 'Percurso, nível, o que levar, ponto de encontro',
  whereHint: 'o app calcula a distância a partir daqui',
  externalUrl: 'Página do evento',
  externalUrlHint: 'Site, inscrição ou rede social do organizador.',
  approvedWarningTitle: 'Este evento está publicado',
  approvedWarning:
    'Ao salvar, o evento volta para análise e sai do app até ser aprovado de novo. Quem já confirmou continua confirmado.',
  rejectedNoteTitle: 'Nota da equipe Bodyprint',
  cancel: 'Cancelar',
  saveDraft: 'Salvar rascunho',
  saveAndSubmit: 'Salvar e enviar para análise',
  saveChanges: 'Salvar alterações',
  submitLocked: 'O envio para análise libera depois que a conta for aprovada.',
  saved: {
    draft: 'Rascunho salvo',
    in_review: 'Alterações salvas',
    approved: 'Evento enviado para análise',
  },
  submitted: 'Evento enviado para análise',
  saveError: 'Não foi possível salvar o evento. Tente de novo',
  resubmitModal: {
    title: 'O evento sai do app até ser aprovado de novo',
    message:
      'As alterações vão para a análise da Bodyprint. Enquanto isso, o evento não aparece no app, e quem já confirmou continua confirmado.',
    confirm: 'Salvar e enviar',
    cancel: 'Continuar editando',
  },
} satisfies TranslationTree;
